import type { Gifts } from '.';

import { createMessage, SB } from '@play-co/replicant';
import { defineMessages } from '../../utils';
import { energyGiftAmount } from './gifts.ruleset';

export default defineMessages<Gifts>()({
  /**
   * Add gifts to user state
   */
  receiveGift: createMessage(SB.object({}), (state, _, info) => {
    const senderId = info.senderId;
    const energy = energyGiftAmount;

    // Create gift on user state
    state.gifts.received[senderId] = {
      sentAt: info.timestamp,
      energy,
    };
  }),
});
